(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();

  function initialize(root) {
    const cards = root.matches?.('[data-product-card]')
      ? [root]
      : root.querySelectorAll?.('[data-product-card]') || [];

    cards.forEach((card) => {
      if (initialized.has(card)) return;
      const image = card.querySelector('.product--card-image');
      const stickers = image?.querySelector('.product-card__stickers');
      if (!image || !stickers) return;
      initialized.add(card);
      let frame = 0;

      const positionStickers = () => {
        frame = 0;
        if (!card.isConnected) return;
        const imageRect = image.getBoundingClientRect();
        if (!imageRect.width) return;
        let top = 8;
        card.querySelectorAll('.product--card-badges .product--badge').forEach((badge) => {
          const styles = getComputedStyle(badge);
          if (styles.display === 'none' || styles.visibility === 'hidden' || !badge.getClientRects().length) return;
          const rect = badge.getBoundingClientRect();
          if (rect.height > 0) {
            const scaleY = image.offsetHeight ? imageRect.height / image.offsetHeight : 1;
            top = Math.max(top, (rect.bottom - imageRect.top) / (scaleY || 1) + 4);
          }
        });
        const value = Math.ceil(top) + 'px';
        if (stickers.style.getPropertyValue('--card-custom-stickers-top') !== value) {
          stickers.style.setProperty('--card-custom-stickers-top', value);
        }
      };

      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(positionStickers);
      };
      const resize = new ResizeObserver(schedule);
      resize.observe(image);
      card.querySelectorAll('.product--card-badges, .product--badge').forEach((badge) => resize.observe(badge));
      const changes = new MutationObserver((records) => {
        if (records.some((record) => record.target !== stickers)) schedule();
      });
      changes.observe(card, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      document.fonts?.ready.then(schedule);
      schedule();
    });
  }

  const start = () => {
    initialize(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const card = node.closest('[data-product-card]');
          initialize(card || node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grouped-swatches"] && !Shopify.designMode) return;
  try {
    (() => {

    if (window.groupedProductSwatchesInitialized) return;

    window.groupedProductSwatchesInitialized = true;



    const setCardLinks = (card, url) => {

      card.querySelectorAll('.product--image, .product--title, .collection-image-only-card').forEach((link) => {

        link.href = url;

      });

    };



    const setCardImage = (card, imageUrl, imageAlt) => {

      if (!imageUrl) return;

      const image = card.querySelector('[data-product-media] img.product--card-image, [data-product-media] img');

      if (!image) return;

      image.removeAttribute('srcset');

      image.removeAttribute('sizes');

      image.src = imageUrl;

      image.alt = imageAlt || '';

    };



    const setActiveSwatch = (card, swatch) => {

      card.querySelectorAll('[data-grouped-swatches]').forEach((group) => {

        group.querySelectorAll('[data-grouped-swatch]').forEach((item) => {

          const active = item.dataset.productId === swatch.dataset.productId;

          item.classList.toggle('is-active', active);

          item.setAttribute('aria-current', active ? 'true' : 'false');

        });

        const selectedColor = group.querySelector('[data-grouped-selected-color]');

        if (selectedColor) selectedColor.textContent = swatch.dataset.colorName || '';

      });

    };



    const updateProductData = (card, swatch, productData) => {

      const url = swatch.dataset.productUrl;

      const title = swatch.dataset.productTitle;

      const titleElement = card.querySelector('.product--title');

      if (titleElement && title) titleElement.textContent = title;

      setCardLinks(card, url);

      setCardImage(card, swatch.dataset.productImage || productData.featured_image, swatch.dataset.productImageAlt || title);

      card.dataset.id = swatch.dataset.productId;

      card.groupedProductData = productData;



      const selectedVariant = productData.variants?.find((variant) => variant.available) || productData.variants?.[0];

      if (selectedVariant) {

        card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {

          input.value = selectedVariant.id;

        });

      }



      const quickView = card.querySelector('quick-view');

      const quickViewButton = card.querySelector('[product-quickview-btn]');

      if (quickView) {

        quickView.dataset.productUrl = url;

        quickView.dataset.productId = swatch.dataset.productId;

      }

      if (quickViewButton) {

        quickViewButton.href = url;

        quickViewButton.dataset.handle = swatch.dataset.productHandle;

      }

    };



    document.addEventListener('change', (event) => {

      const optionInput = event.target.closest('[data-product-card] .productOption');

      if (!optionInput) return;

      const card = optionInput.closest('[data-product-card]');

      const productData = card?.groupedProductData;

      if (!card || !productData?.variants) return;



      window.setTimeout(() => {

        const selectedVariant = productData.variants.find((variant) => {

          return variant.available && variant.options?.includes(optionInput.value);

        }) || productData.variants.find((variant) => variant.available) || productData.variants[0];



        if (selectedVariant) {

          card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {

            input.value = selectedVariant.id;

          });

        }



        const activeSwatch = card.querySelector('[data-grouped-swatch].is-active');

        if (activeSwatch) {

          setCardImage(card, activeSwatch.dataset.productImage, activeSwatch.dataset.productImageAlt);

        }

      }, 0);

    });



    document.addEventListener('click', async (event) => {

      const swatch = event.target.closest('[data-grouped-swatch]');

      if (!swatch) return;

      const card = swatch.closest('[data-product-card]');

      if (!card) return;



      event.preventDefault();

      event.stopPropagation();

      if (swatch.classList.contains('is-active')) return;



      card.classList.add('is-grouped-product-loading');



      try {

        const productUrl = swatch.dataset.productUrl.split('?')[0];

        const response = await fetch(`${productUrl}.js`, { credentials: 'same-origin' });

        if (!response.ok) throw new Error('Product request failed');

        const productData = await response.json();

        updateProductData(card, swatch, productData);

        setActiveSwatch(card, swatch);

      } catch (error) {

        window.location.assign(swatch.href);

      } finally {

        card.classList.remove('is-grouped-product-loading');

      }

    }, true);

  })();
  } catch(e) { console.error(e); }
})();

})();
